import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { ContextService } from '../../core/context/context.service';

@Pipe({
  name: 'pgsCurrency'
})
export class PgsCurrencyPipe implements PipeTransform {

  constructor(private currencyPipe: CurrencyPipe, private contextService: ContextService) {
  }

  transform(value: any, showSign = false): any {
    let transformedValue =
      this.currencyPipe.transform(value, this.contextService.localeData[15], undefined,
        this.contextService.priceDecimals, this.contextService.locale);

    if (!showSign && transformedValue) {
      transformedValue = transformedValue.replace(this.contextService.localeData[15], '');
    }

    return transformedValue;
  }
}
